import RecommendationsListItem from './RecommendationsListItem';

export default RecommendationsListItem;
